<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  goal: { type: Object, default: null },
});

const { t } = useI18n();
const brl = v => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v ?? 0);

const percentage = computed(() => Math.min(props.goal?.percentage ?? 0, 100));

const barColor = computed(() => {
  if (!props.goal) return 'bg-n-slate-5';
  if (percentage.value >= 100) return 'bg-n-teal-9';
  if (percentage.value >= 50)  return 'bg-n-amber-9';
  return 'bg-n-ruby-9';
});

const textColor = computed(() => {
  return props.goal ? 'text-n-slate-12' : 'text-n-slate-9';
});

const formattedRealized = computed(() => {
  if (!props.goal) return null;
  return props.goal.goal_type === 'quantity' ? props.goal.realized : brl(props.goal.realized);
});

const formattedGoal = computed(() => {
  if (!props.goal) return null;
  return props.goal.goal_type === 'quantity' ? props.goal.goal_value : brl(props.goal.goal_value);
});
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <!-- Label linha superior -->
    <div class="flex items-center justify-between">
      <span class="text-xs text-n-slate-10">
        <template v-if="goal">
          {{ formattedRealized }} / {{ formattedGoal }}
        </template>
        <template v-else>
          {{ $t('SALES.GOAL_STATUS.NO_GOAL') }}
        </template>
      </span>
      <span class="text-sm font-bold" :class="textColor">
        {{ percentage }}%
      </span>
    </div>

    <!-- Barra -->
    <div class="h-2 bg-n-slate-3 rounded-full overflow-hidden">
      <div
        class="h-full rounded-full transition-all duration-700"
        :class="barColor"
        :style="{ width: `${percentage}%` }"
      />
    </div>
  </div>
</template>
